import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormLabel, Select, MenuItem, FormHelperText } from "@mui/material";

import { entityTypes } from "../../../../../../Entity/enums/entity-type";
import { EditEntityProfileData } from "../../../../../types/editEntityProfile-type";

const EntityTypeField = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });
  const { t: tEntity } = useTranslation("entity");
  const { control } = useFormContext<EditEntityProfileData>();

  return (
    <Controller
      name="type"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error} fullWidth>
          <FormLabel
            sx={{
              color: "var(--Dark---800, #414141)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "24px",
            }}
          >
            {t("entityType")}
          </FormLabel>
          <Select key={field.value} {...field} displayEmpty value={field.value ?? ""}>
            <MenuItem value="" disabled>
              {t("selectEntityType")}
            </MenuItem>
            {entityTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {tEntity(`entityType.${type}`)}
              </MenuItem>
            ))}
          </Select>
          {error?.message && <FormHelperText sx={{ color: "#CC3E3E" }}>{t(error.message)}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default EntityTypeField;
